import React from 'react';

function LegacyGridHost({ rootRef, canvasContainerRef, deckId }) {
  return (
    <div className="pred-native-grid" ref={rootRef} style={{ width: '100vw', height: '100dvh', overflow: 'hidden' }}>
      <div id="loading">
        <div className="loading-text">INITIALIZING THE GRID</div>
        <div className="loading-bar">
          <div className="loading-progress" id="loading-progress" />
        </div>
      </div>

      <div id="canvas-container" ref={canvasContainerRef} />
      <div className="crt-overlay" />

      <div className="sector-takeover" id="sectorTakeover">
        <div className="sector-takeover-text" id="sectorTakeoverText" />
      </div>

      <div id="hud-overlay">
        <div className="hud-top">
          <div className="hud-sector" id="hud-sector">
            SECTOR
          </div>
        </div>

        <div className="dashboard-sidebar">
          <div className="hud-title" id="hud-title">
            TITLE
          </div>
          <div className="hud-story" id="hud-story">
            Story...
          </div>
          <div className="hud-logic" id="hud-logic">
            Logic...
          </div>
          <div style={{ marginTop: 20, paddingTop: 15, borderTop: '1px solid rgba(255,255,0,0.2)' }}>
            <div id="hud-signal-validation" />
            <div
              id="hud-mitigation-note"
              style={{
                display: 'none',
                marginTop: 10,
                fontSize: '0.85rem',
                color: 'var(--safety-yellow)',
                opacity: 0.8
              }}
            >
              <span style={{ marginRight: 10 }}>MITIGATION</span>
              <button id="hud-mitigation-toggle" type="button" className="hud-mitigation-toggle">
                OFF
              </button>
            </div>
          </div>
          <div className="hud-cta" id="hud-cta">
            <div className="hud-cta-actions" id="hud-cta-actions" />
          </div>
        </div>
      </div>

      <div className="hud-bottom hud-hidden" id="hud-bottom">
        <div className="hud-countermeasures" id="hud-countermeasures" />
      </div>

      <div className="control-deck" id="control-deck" style={{ display: 'none' }}>
        <div className="deck-group">
          <span className="deck-label">NAVIGATION</span>
          <button id="prev-btn" className="nav-btn" disabled>
            ◄
          </button>
          <button id="grid-btn" className="nav-btn">
            GRID
          </button>
          <button id="next-btn" className="nav-btn">
            ►
          </button>
        </div>
        <div className="deck-group">
          <span className="deck-label">SIMULATION</span>
          <button id="mitigation-btn" className="nav-btn">
            MIT
          </button>
        </div>
      </div>
    </div>
  );
}

export default LegacyGridHost;
